export default "__VITE_ASSET__BcOUgVDK__"